import { Recipe } from 'common/hooks/useProducer';
import exhaustivnessCheck from 'common/utils/exhaustivnessCheck';

import { ModalChoicesState } from 'features/banking/agentBanking/localState/states';
import { ModalChoicesActions } from 'features/banking/agentBanking/localState/actions';

export const transferChoicesRecipe: Recipe<
  ModalChoicesState,
  ModalChoicesActions
> = (draft, action) => {
  switch (action.type) {
    case 'transfer/choices/started':
      draft.pendingDepositChoices = true;
      return;

    case 'transfer/choices/finished':
      draft.pendingDepositChoices = false;
      draft.depositChoices = action.choices;
      draft.error = action.error;
      return;

    case 'transfer_request/choices/started':
      draft.pendingWithdrawalChoices = true;
      return;

    case 'transfer_request/choices/finished':
      draft.pendingWithdrawalChoices = false;
      draft.withdrawalChoices = action.choices;
      draft.error = action.error;
      return;

    case 'account_transfer/choices/started':
      draft.pendingTransferChoices = true;
      return;

    case 'account_transfer/choices/finished':
      draft.pendingTransferChoices = false;
      draft.transferChoices = action.choices;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
